<template>
  <div :style="loginBackground" style="width:100%; height:100%">
    <v-container fill-height>

      <v-row>
        <v-col cols="12">
          <v-img :src="require(`@/assets/Hefe_White.svg`)" contain height="60" alt="Hefe" justify="start">
          </v-img>
        </v-col>
      </v-row>

      <v-row justify="center" no-gutters>
        <p :class="`white--text ${ $vuetify.breakpoint.xs ? 'display-2 text-center font-weight-bold' : $vuetify.breakpoint.sm ? 'display-4 text-center font-weight-bold' : 'display-4 text-center font-weight-bold' }`">
          {{ $language.login['Be the boss'] }}
        </p>
      </v-row>
      <v-row>
        <v-col cols="12">

        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <v-row justify="center">
            <v-btn large :style="`width: ${ $vuetify.breakpoint.xs ? '90%' : $vuetify.breakpoint.sm ? '60%' : '30%' }`" class="text-none grey--text text--darken-3 mb-4" color="white" @click="loginGoogle">
              <v-row no-gutters justify="center" align="center">
                <v-col cols="1">
                  <v-icon color="#DB4437">fab fa-google</v-icon>
                </v-col>
                <v-col cols="8" class="pl-4" align="start">
                  <div>{{ $language.login['Sign in with Google'] }}</div>
                </v-col>
              </v-row>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row justify="center">
            <v-btn large :style="`width: ${ $vuetify.breakpoint.xs ? '90%' : $vuetify.breakpoint.sm ? '60%' : '30%' }`" class="text-none grey--text text--darken-3 mb-4" color="white" @click="loginFacebook">
              <v-row no-gutters justify="center" align="center">
                <v-col cols="1">
                  <v-icon color="#3b5998">fab fa-facebook</v-icon>
                </v-col>
                <v-col cols="8" class="pl-4" align="start">
                  <div>{{ $language.login['Sign in with Facebook'] }}</div>
                </v-col>
              </v-row>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="6" sm="4">
          <v-select dark :item-color="$vuetify.theme.dark?'grey darken-4':'white'" flat v-model="selected" :items="languages" hide-details outlined @change="change" background-color="transparent">
            <template slot="item" slot-scope="{ item }">
              <img :src="item.icon" class="pl-1 mr-4" height="25px" :alt="item.key"><span :class="`${$vuetify.theme.dark?'white--text':'grey--text text--darken-3'} `">{{ item.name }}</span>
            </template>
            <template slot="selection" slot-scope="{ item }">
              <img :src="item.icon" class="pl-1 mr-4" height="25px" :alt="item.key"><span class="ml-3">{{ item.name }}</span>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">

        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import {
  mapState, mapGetters
} from 'vuex'
import variables from '@/custom/variables'
const fb = require('@/services/firebaseConfig.js')
export default {
  components: {
  },
  data () {
    return {
      loginBackground: {
        // 'background-color': 'black',
        // 'background-image': `url(${ require('@/assets/hefe-test.jpg') })`,
        'background-image': `linear-gradient(to bottom, rgba(0,0,0,0.33) 0%,rgba(0,0,0,0.50) 100%), url(${require('@/assets/topography.svg')})`,
        'background-position': 'center center',
        'background-repeat': 'repeat scroll',
        'background-size': 'cover'
      },
      loginForm: {
        email: '',
        password: ''
      },
      signupForm: {
        name: '',
        title: '',
        email: '',
        password: ''
      },
      passwordForm: {
        email: ''
      },
      showLoginForm: true,
      showForgotPassword: false,
      passwordResetSuccess: false,
      performingRequest: false,
      errorMsg: '',
      appVerifier: null,
      phone: '',
      verificationId: '',
      verificationCode: '',
      languages: variables.languages,
      dense: true,
      selected: null
    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser', 'loading', 'language']),
    ...mapGetters(['getLanguage'])
  },
  created: function () {
    this.selected = variables.languages.find(el => {
      return el.key === this.getLanguage
    })
  },
  mounted () {

    // this.$nextTick(function () {
    //   this.appVerifier = new fb.firebase.auth.RecaptchaVerifier(
    //
    //     'recaptcha-container', {
    //       size: 'invisible'
    //     });
    //   // fb.ui.start('#firebaseui-auth-container', fb.uiConfig)
    //   this.appVerifier.render().then((widgetId) => {
    //     window.recaptchaWidgetId = widgetId;
    //   });
    // })
  },
  methods: {
    change (language) {
      this.$store.dispatch('setLanguage', language.key)
    },

    phoneAuth () {
      var provider = new fb.firebase.auth.PhoneAuthProvider()
      provider.verifyPhoneNumber('+14084764548', this.appVerifier)
        .then(function (verificationId) {
          this.verificationId = verificationId
        }.bind(this))
        .catch(function (err) {
          console.log(err)
        })
    },
    loginPhone () {
      fb.auth.signInWithCredential(fb.firebase.auth.PhoneAuthProvider.credential(this.verificationId,
        '123456')).then(user => {
        this.$store.commit('setCurrentUser', user)
        this.$store.dispatch('fetchUserProfile')
        this.performingRequest = false
      }).catch(err => {
        console.log(err)
        this.performingRequest = false
        this.errorMsg = err.message
      })
    },
    toggleForm () {
      this.errorMsg = ''
      this.showLoginForm = !this.showLoginForm
    },
    togglePasswordReset () {
      if (this.showForgotPassword) {
        this.showLoginForm = true
        this.showForgotPassword = false
        this.passwordResetSuccess = false
      } else {
        this.showLoginForm = false
        this.showForgotPassword = true
      }
    },
    loginFacebook () {
      this.performingRequest = true
      var provider = new fb.firebase.auth.FacebookAuthProvider()
      fb.auth.signInWithRedirect(provider).then(user => {
        this.performingRequest = false
      }).catch(err => {
        console.log(err)
        this.performingRequest = false
        this.errorMsg = err.message
      })
    },
    loginGoogle () {
      this.performingRequest = true
      var provider = new fb.firebase.auth.GoogleAuthProvider()
      provider.setCustomParameters({
        prompt: 'select_account'
      })
      fb.auth.signInWithRedirect(provider).then(user => {
        this.performingRequest = false
      }).catch(err => {
        this.performingRequest = false
        this.errorMsg = err.message
      })

      // EMAIL LOGIN

      // fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
      //     this.$store.commit('setCurrentUser', user)
      //     this.$store.dispatch('fetchUserProfile')
      //     this.performingRequest = false
      //     this.$router.push('/dashboard')
      // }).catch(err => {
      //     console.log(err)
      //     this.performingRequest = false
      //     this.errorMsg = err.message
      // })
    },
    signup () {
      this.performingRequest = true

      fb.auth.createUserWithEmailAndPassword(this.signupForm.email, this.signupForm.password).then(user => {
        this.$store.commit('setCurrentUser', user)

        // create user obj
        fb.usersCollection.doc(user.uid).set({
          name: this.signupForm.name,
          title: this.signupForm.title
        }).then(() => {
          this.$store.dispatch('fetchUserProfile')
          this.performingRequest = false
          this.$router.push('/dashboard')
        }).catch(err => {
          console.log(err)
          this.performingRequest = false
          this.errorMsg = err.message
        })
      }).catch(err => {
        console.log(err)
        this.performingRequest = false
        this.errorMsg = err.message
      })
    },
    resetPassword () {
      this.performingRequest = true

      fb.auth.sendPasswordResetEmail(this.passwordForm.email).then(() => {
        this.performingRequest = false
        this.passwordResetSuccess = true
        this.passwordForm.email = ''
      }).catch(err => {
        console.log(err)
        this.performingRequest = false
        this.errorMsg = err.message
      })
    }
  }
}
</script>
